import {SiteConfigContextValue} from '@common/core/settings/site-config-context';

export const SiteConfig: Partial<SiteConfigContextValue> = {
  auth: {
    redirectUri: '/agent/tickets',
    secondaryRedirectUri: '/agent/tickets',
    adminRedirectUri: '/admin',
  },
  admin: {
    ads: [],
  },
  tags: {
    types: [{name: 'category'}, {name: 'status'}],
  },
  demo: {
    loginPageDefaults: 'singleAccount',
    email: 'admin@demo.com',
    password: 'demo',
  },
  settings: {
    showIncomingMailMethod: true,
  },
};
